export default "__VITE_ASSET__UdbSCMnV__"